import { render, staticRenderFns } from "./verification-confirm.vue?vue&type=template&id=78e3707f"
import script from "./verification-confirm.vue?vue&type=script&lang=js"
export * from "./verification-confirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports